import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { Header } from './shared/header/header';
import { Footer } from './shared/footer/footer';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Footer],
  template: `
    <app-header />
    <main class="contenido">
      <router-outlet />
    </main>
    <app-footer />
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      min-height: 100vh;
    }

    .contenido {
      flex: 1;
      /* Compensa el header fijo de 96px */
      padding-top: 96px;
      background: var(--c-neutrals-grey_0);
    }

    @media (max-width: 900px) {
      .contenido {
        /* Header mobile compacto (64px) */
        padding-top: 64px;
      }
    }
  `,
})
export class App {}
